<template>
    <div>
      <b-card no-body>
        <b-card-header>
          <div class="align-items-center row">
            <div class="col d-flex align-items-center justify-content-between">
              <h3 class="card-title mb-0">{{ $t("Kiradaki Ürünler") }}</h3>
              <div class="d-flex">
                <b-form-group class="mb-0 mr-2">
                  <b-form-select v-model="company" :options="companies" v-if="getType=='all'" @change="refreshTable" />
                </b-form-group>
                <b-form-group class="mb-0">
                  <b-form-select v-model="filterType" :options="[
                    { text: 'Kiradaki Ürünler', value: 'now' },
                    { text: 'Geçmiş Kiralar', value: 'past' },
                    { text: 'Gelecek Kiralar', value: 'future' },
                  ]" @change="refreshTable" />
                </b-form-group>
              </div>
            </div>
          </div>
        </b-card-header>

        <b-table ref="table" class="align-items-center" thead-class="thead-light" :fields="fields" :items="getItems" responsive show-empty>

          <template v-slot:table-busy>
            <div style="width: 100%; text-align:center;">
              <b-spinner label="Spinning"></b-spinner>
            </div>
          </template>

          <template v-slot:empty>
            <b-alert variant="warning" show>{{ $t("Henüz bir şey eklenmemiş") }}!</b-alert>
          </template>
          <template v-slot:cell(issue_date)="data">
            {{moment(data.item.issue_date).format('DD-MM-YYYY')}}
          </template>
          <template v-slot:cell(delivery_date)="data">
            {{moment(data.item.delivery_date).format('DD-MM-YYYY')}}
          </template>
          <template v-slot:cell(id)="data">

            {{data.item.id}}
          </template>
          <template v-slot:cell(actions)="data">
            <!--            <b-button variant="outline-success" @click="paymentModal(data.item.id)">+ Ödeme Gir</b-button>-->
            <b-button variant="warning" v-if="data.item.status=='active' && getType!='all'"   @click="releaseModal(data.item.id)">
              {{ $t("Teslim Al") }} </b-button>
          </template>

        </b-table>
        <div class="w-100 text-center d-flex-wrap align-items-center justify-content-center mt-2 mb-3">
          <b-button variant="secondary" v-if="cPage!=1" @click="cPage=1; refreshTable();"><<</b-button>
          <b-button variant="secondary" v-if="cPage!=1"
                    @click="cPage-10>=1 ? cPage=cPage-10 : cPage=1; refreshTable();"><
          </b-button>
          <b-button :variant="cPage==page ? 'primary':'secondary'" v-for="page in services.last_page"
                    @click="cPage=page; refreshTable();" v-bind:key="page" v-if="page<(cPage+5) && (page>cPage-5)">
            {{ page }}
          </b-button>

          <b-button variant="secondary" v-if="cPage!=services.last_page"
                    @click="cPage+10<=services.last_page ? cPage=cPage+10 : cPage=services.last_page; refreshTable();">
            >
          </b-button>
          <b-button variant="secondary" v-if="cPage!=services.last_page"
                    @click="cPage=services.last_page; refreshTable();"> >>
          </b-button>
        </div>
      </b-card>
      <b-modal ref="releaseModal" title="Teslim Al" @hide="hidePaymentModal">
        <b-form-group>
          <label>{{ $t("Teslim alınan tarih") }}</label>
          <b-form-input v-model="releaseData.delivered_date" type="date" />
        </b-form-group>
        <b-form-checkbox v-model="releaseData.clear_credits">{{ $t("Bu kiranın(varsa) kalan ödemelerini tamamla") }}.</b-form-checkbox>
        <template v-slot:modal-footer>
          <b-button variant="secondary" @click="$refs.releaseModal.hide()">{{ $t("İptal") }}</b-button>
          <b-button variant="primary" @click="releaseAction">{{ $t("Teslim Al") }}</b-button>
        </template>
      </b-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from "moment";

export default {
  props:{
    client:null
  },
  computed:{
    ...mapGetters(['user','companies']),
    getType(){
      return this.$route.params.type
    }
  },
  mounted(){
    if(this.client!=null){

      this.fields=this.fields.filter(f=>f.key!='client.full_name')
      this.fields=this.fields.filter(f=>f.key!='client.phone')
    }
  },
  data () {
    return {
      moment,
      company:null,
      filterType:'now',
      cPage:1,
      releaseData: {},
      services:{},
      paymentData: {
        payment_date: moment().format('YYYY-MM-DD'),
      },
      fields: [
        { key: 'id', label: 'Sıra No' },
        { key: 'client.full_name', label: 'Müşteri Adı' },
        { key: 'client.phone', label: 'Telefonu' },
        { key: 'service.name', label: 'Ürün Adı' },
        { key: 'issue_date', label: 'Alış Tarihi' },
        { key: 'delivery_date', label: 'Teslim Edilmesi Gereken Tarih' },
        { key: 'price', label: 'Peşinat' },
        { key: 'total_price', label: 'Toplam Ücret' },
        // { key: 'service.company.full_name', label: 'Bayi' },
        { key: 'actions', label: '', tdClass: 'text-right' },
      ],
    }
  },
  methods: {
    ...mapActions(['getLeasedProducts', 'createPayment', 'release']),
    releaseAction() {
      this.release(this.releaseData).then(response => {
        this.success(response.data.message);
        this.$refs.releaseModal.hide();
        this.refreshTable();
      }).catch(error => {
        this.error(error.response.data.message);
      })
    },
    releaseModal(id) {
      this.releaseData = {
        delivered_date: moment().format('YYYY-MM-DD'),
        lease_id: id,
        clear_credits: true,
      };
      this.$refs.releaseModal.show();
    },
    paymentAction() {
      this.createPayment(this.paymentData).then(response => {
        this.success(response.data.message);
        this.$refs.paymentModal.hide();
        this.refreshTable();
      }).catch(error => {
        this.error(error.response.data.message);
      });
    },
    paymentModal(id) {
      this.paymentData.lease_id = id;
      this.$refs.paymentModal.show();
    },
    hidePaymentModal() {
      this.paymentData = {
        payment_date: moment().format('YYYY-MM-DD'),
      };
    },
    refreshTable () {
      this.$refs.table.refresh()
    },
    getItems () {
      let obj={filterType:this.filterType,getType:this.getType,company:this.company,page:this.cPage};
      if(this.client!=null)
        obj.client_id=this.client
      return this.getLeasedProducts(obj)
          .then(data => data.data).then(response => {
            this.services={
              last_page:response.last_page
            }
            return response.data;
          })
    },
  }
}
</script>

<style scoped>

</style>